import React, { Component } from "react";
import UI from "../../shared/Components/UI/js";
import MainLayout from "../_components/MainLayout";
import UdbTable from "../../ComponentsFC/admin/udb/UdbTable";

const context = "admin";
export default class UdbPage extends Component {
  constructor() {
    super();
    this.state = {};
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "UDB",
      context: context,
    });
  }

  render() {
    const _this = this;

    return (
      <MainLayout context={context} _this={_this}>
        <UdbTable _this={_this}/>
      </MainLayout>
    );
  }
}
